import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchWhRegistrationResults } from 'src/app/core/models/transport-operation/search-whRegistration-results';
import { AddWarehousingRegistrationRequest } from 'src/app/core/models/transport-operation/warehousing-registration';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class TruckCostAllocationService {

  constructor(
    private http: HttpClient
  ) { }

  searchCrossBoundry(params: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/searchCrossBoundry`;
    return this.http.post<SearchWhRegistrationResults[]>(url, params);
  }

  searchDataForCrossBoundry(params: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/searchDataForCrossBoundry`;
    return this.http.post<SearchWhRegistrationResults[]>(url, params);
  }

  cancelCrossBoundry(params: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/cancelCrossBoundry`;
    return this.http.post(url, params);
  }

  createCrossBoundryMA(request : any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/createCrossBoundryMA`;
    return this.http.post(url,request);
  }

  updateCrossBoundry(request : any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/updateCrossBoundry`;
    return this.http.post(url,request);
  }

  queryCrossBoundryAddressInfo(seqNos: any):Observable<any>{
    const url = `${environment.logisticsApiUrl}/crossBoundry/queryAddressInfo`;
    return this.http.post(url,seqNos);
  }

  getCrossBoundryDetail(seqNo: number): Observable<any> {
    const url = `${environment.logisticsApiUrl}/crossBoundry/searchCrossBoundryDetail/${seqNo}`;
    return this.http.get(url);
  }

  async searchCrossBoundryByCBNo(crossBoundryNo: string) {
    const url = `${environment.logisticsApiUrl}/crossBoundry/searchCrossBoundryByCBNo/${crossBoundryNo}`;
    return await this.http.get(url).toPromise();
  }

}
